// extracted by mini-css-extract-plugin
export default {"average":"styles-module--average--2JPhk","show":"styles-module--show--2SmKj","averageText":"styles-module--averageText--1Or2x","mobile":"styles-module--mobile--melqv"};